/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useTranslation } from '../../../locale/useTranslation';
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { PROTOTYPETRIGGERTYPEENUM, SCHEDULECOLORPREFERENCE } from '../../../framework/constant/constant';
import SecondaryEventGanntView from './SecondaryEventGanntView';
import { utility } from '../../../framework/utility/utilityProvider';
import contextMenuItem from '../../../components/contextMenuItem';
import { ContextMenu } from 'primereact/contextmenu';

const DATA_ITEM_KEY = "_id";
const SELECTED_FIELD = "selected";
export const SchedulingSecondaryEvent = (props) => {

    const { selectedState = {}, showTimeLineView = false, hideTriggerStartEnd = false } = props;
    const lang = useTranslation();
    const [secondaryEvents, setSecondaryEvents] = useState([]);
    const [timelineViewData, setTimelineViewData] = useState([]);
    const [viewMode, setViewMode] = useState(true);
    const handleView = () => { setViewMode(!viewMode) }


    const cm = useRef()
    const [selectedStateGrid, setSelectedStateGrid] = useState([]); //children multiple selection grid
    const selectedStateGridRef = useRef(selectedState);
    const selectedStateRefSetter = (data) => {
        selectedStateGridRef.current = data;
        setSelectedStateGrid(data);
        // props.setSelectedState && props.setSelectedState(data);
    };

    useEffect(() => {
        if (selectedState != undefined && selectedState.Prototypes) {
            if (selectedState.Prototypes.length > 0) {
                let finalData = getSecondaryEventsWithActualTriggers(selectedState, selectedState.Prototypes);
                setSecondaryEvents(finalData);
                setTimelineViewData(finalData);              
            } else {
                setSecondaryEvents([]);
                setTimelineViewData([]);
            }
        }

    }, [selectedState]);

    const getSecondaryEventsWithActualTriggers = (selectedSchedule, secondaryEvents) => {

        let finalSe = [];

        if(secondaryEvents && secondaryEvents.length > 0){


            for (let index = 0; index < secondaryEvents.length; index++) {
                let element = secondaryEvents[index];
                const selectedScheduleSlotEndTime = selectedSchedule.SlotDateTime + selectedSchedule.Duration;

                // we will calculate start trigger first
                if(element.StartTriggerType && element.StartTriggerType.ID == PROTOTYPETRIGGERTYPEENUM.Duration){
                    element.TriggerStartTime = element.IsStartNegative ? selectedSchedule.SlotDateTime - element.StartOffset : selectedSchedule.SlotDateTime + element.StartOffset;
                }
                else if(element.StartTriggerType && element.StartTriggerType.ID == PROTOTYPETRIGGERTYPEENUM.ParentEnd){
                    element.TriggerStartTime = element.IsStartNegative ? (selectedScheduleSlotEndTime - element.StartOffset) : (selectedScheduleSlotEndTime + element.StartOffset);
                }
                else{ // default parent start
                    element.TriggerStartTime = element.IsStartNegative ? selectedSchedule.SlotDateTime - element.StartOffset : selectedSchedule.SlotDateTime + element.StartOffset;
                }



                // we will calculate end trigger now
                if(element.EndTriggerType && element.EndTriggerType.ID == PROTOTYPETRIGGERTYPEENUM.Duration){
                    element.TriggerEndTime = element.IsEndNegative ?  selectedSchedule.SlotDateTime - element.EndOffset : selectedScheduleSlotEndTime + element.EndOffset;
                }
                else if(element.EndTriggerType && element.EndTriggerType.ID == PROTOTYPETRIGGERTYPEENUM.ParentStart){
                    element.TriggerEndTime = element.IsEndNegative ? (selectedSchedule.SlotDateTime - element.EndOffset) : (selectedSchedule.SlotDateTime + element.EndOffset);
                }
                else{ // default parent end
                    element.TriggerEndTime = element.IsEndNegative ? selectedScheduleSlotEndTime - element.EndOffset : selectedScheduleSlotEndTime + element.EndOffset;
                }

                finalSe.push(element);
            }
        }
        return finalSe;
    }

    const GridRowRenderScheduleSecondaryEvents = (tr, props) => {
        let style = SCHEDULECOLORPREFERENCE.lightgrey;
        //---
        const trProps = {
            style: style,
            draggable: false,
            onDragOver: (e) => {
                e.preventDefault();
            },
            onContextMenu: (e) => {
                e.preventDefault();
                cm.current?.show(e);

                let dataToSelect =
                    selectedStateGridRef.current.length > 1
                        ? selectedStateGridRef.current
                        : [props.dataItem];

                selectedStateRefSetter(dataToSelect);
            },
        };
        //---
        return React.cloneElement(tr, { ...trProps }, tr.props.children);
    };

    const onSelectionChange = (event) => {
        //console.log(event);
        const ctrlKey = event.ctrlKey || event.metaKey;
        const rowIndex = event.startRowIndex;
        const dataItems = event.dataItems;
        const dataItem = dataItems[rowIndex];
        const shiftKey = event.shiftKey;

        var newSelectedData = [];


        if (ctrlKey) {
            let alreadySelected = selectedStateGrid.some(item => item._id == dataItem._id);
            if (alreadySelected) {
                newSelectedData = selectedStateGrid.filter(item => item._id != dataItem._id)
            } else {
                newSelectedData = [...selectedStateGrid, dataItem]
            }
        } else if (shiftKey) {
            let start = Math.min(rowIndex, selectedStateGrid.length > 0 ? dataItems.findIndex(x => x._id == selectedStateGrid[0]._id) : 0);
            let end = Math.max(rowIndex, selectedStateGrid.length > 0 ? dataItems.findIndex(x => x._id == selectedStateGrid[0]._id) : 0);
            newSelectedData = dataItems.slice(start, end + 1);
        } else {
            let alreadySelected = selectedStateGrid.length == 1 && selectedStateGrid[0]._id == dataItem._id ? true : false
            if (alreadySelected) {
                newSelectedData = []
            } else {
                newSelectedData = [dataItem]
            }
        }
        selectedStateRefSetter(newSelectedData);

    }

    return (
        <div style={{
            position: 'absolute',
            left: 0,
            height: "80%",
            width: '100%',
            padding: '8px',
            marginTop: '-15px'
        }}>
            {showTimeLineView && <> <div style={{ float: 'right', marginTop: "-6px", cursor: "pointer", fontSize: '12px' }} onClick={handleView} title={viewMode ? lang.grid_view_label : lang.time_line_view_tooltip}><i className={`fas ${viewMode ? 'fa-table-cells' : 'fa-timeline'} fa-xl`} /></div><br /></>}

            {viewMode ?
                <Grid
                    data={secondaryEvents?.map(item => {
                        item[SELECTED_FIELD] = selectedStateGrid.some(dataItem => dataItem._id == item._id)
                        return item;
                    })}
                    rowRender={GridRowRenderScheduleSecondaryEvents}
                    style={{ height: "100%" }}
                    resizable={true}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    selectable={{
                        enabled: true,
                        drag: true,
                        cell: false,
                        mode: { value: "multiple", abel: "Multiple selection mode" },
                    }}
                    onSelectionChange={(e) => onSelectionChange(e)}
                >
                    <Column field="Name" title={lang.name_column} width="120px" />
                    <Column field="ID" title={lang.id_column} width="120px" />
                    <Column field="ProtoTypeSource.Name" title={lang.source_column} width="120px" />
                    <Column field="StartTriggerType.Description" title={lang.start_type_column} width="120px" />
                    <Column field="StartOffset" title={lang.start_offset_column} cell={TimeCell} width="120px" />
                    {!hideTriggerStartEnd && <Column field="TriggerStartTime" title={lang.trigger_start_time_label} cell={TimeCell} width="120px" />}
                    <Column field="EndTriggerType.Description" title={lang.end_type_column} width="120px" />
                    <Column field="EndOffset" title={lang.end_offset_column} cell={TimeCell} width="120px" />
                    {!hideTriggerStartEnd && <Column field="TriggerEndTime" title={lang.trigger_end_time_label} cell={TimeCell} width="120px" />}
                    <Column field="Text1" title={lang.text_1_column} width="180px" />
                    <Column field="Text2" title={lang.text_2_column} width="180px" />
                    <Column field="Text3" title={lang.text_3_column} width="180px" />
                    <Column field="Text4" title={lang.text_4_column} width="180px" />
                    <Column field="Text5" title={lang.text_5_column} width="180px" />
                    <Column field="Text6" title={lang.text_6_column} width="180px" />

                </Grid>
                :
                <SecondaryEventGanntView selectedState={selectedState} timelineViewData={timelineViewData} />}

            {/* CONTEXT MENU */}
            <ContextMenu
                ref={cm}
                model={[
                    {
                        label: `${lang.delete_selected_menutext}`,
                        icon: "pi pi-fw pi-trash",
                        command: (e) => {
                            cm.current?.hide(e);
                            console.log(selectedState)
                            console.log(selectedStateGrid)
                            setSecondaryEvents(secondaryEvents.filter((item) => !selectedStateGrid.includes(item)));
                            props.onDeleteSelectedSecondary({ selectedItem : selectedState, selectedPrototype : selectedStateGrid });
                            selectedStateRefSetter([]);
                        },
                        template: contextMenuItem
                    },
                    {
                        label: `${lang.delete_selected_in_whole_menutext}`,
                        icon: "pi pi-fw pi-trash",
                        command: (e) => {
                            cm.current?.hide(e);
                            console.log(selectedState)
                            console.log(selectedStateGrid)
                            setSecondaryEvents(secondaryEvents.filter((item) => !selectedStateGrid.includes(item)));
                            props.onDeleteSelectedAllSecondaryEvent({ selectedItem : selectedState, selectedPrototype : selectedStateGrid });
                            selectedStateRefSetter([]);
                        },
                        template: contextMenuItem
                    },
                    // {
                    //     label: `${lang.delete_header_actionbutton_menutext}`,
                    //     icon: "pi pi-fw pi-trash",
                    //     command: (e) => {
                    //         cm.current?.hide(e);
                    //         // scheduleHeaderDelete();
                    //     },
                    //     template: contextMenuItem
                    // },
                ]}
            />
        </div>

    )
}
